import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { Product } from "../../../domain/entities/product/Product";
import { CheckoutSoldOutTrackingEvent, Constants, PROJECT, TrackingEventName } from "./tracking";

interface TrackCheckoutSoldOutFunctionArgs {
  readonly variantId: string;
  readonly stockAvailable: boolean;
  readonly products: Product[];
}

interface TrackCheckoutSoldOutFunction {
  (args: TrackCheckoutSoldOutFunctionArgs): void;
}

interface UseTrackCheckoutSoldOutFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackCheckoutSoldOutFunction {
  (agrs: UseTrackCheckoutSoldOutFunctionArgs): TrackCheckoutSoldOutFunction;
}

const useTrackCheckoutSoldOut: UseTrackCheckoutSoldOutFunction = ({ country, segment, tradename, userId }) => {
  const emitUserEvent = useEmitUserEvent<CheckoutSoldOutTrackingEvent>();

  const trackCheckoutSoldOut: TrackCheckoutSoldOutFunction = useCallback(
    ({ products, stockAvailable, variantId }) => {
      emitUserEvent({
        event: TrackingEventName.CHECKOUT_SOLD_OUT,
        eventCategory: TrackingEventCategory.LOOK_IN,
        store: country,
        section: PROJECT,
        segment,
        tradename,
        userId,
        userUuid: userId,
        items_str: variantId,
        stock_available: stockAvailable,
        items: products?.map((product) => ({
          item_id: product._variantId,
          item_list_name: Constants.COMPLETE_YOUR_LOOK_LIST,
        })),
      });
    },
    [country, emitUserEvent, segment, tradename, userId],
  );

  return trackCheckoutSoldOut;
};

export { useTrackCheckoutSoldOut };
